module.exports = __webpack_public_path__ + "img/home_return_myhome.1f71d4d2.png";